import React from 'react'
import { buildSearchBox } from '@coveo/headless'
import { coveoSearchEngine } from '../coveo-search-results/engine'
import Input from './Input'

const SearchBox = ({
  coveoOrganizationId,
  coveoApiKey,
  placeholder,
  urlSearchPage,
  clearButtonLabel,
  searchButtonLabel
}) => {
  const coveoHeadlessSearchEngine =
    coveoOrganizationId && coveoApiKey
      ? coveoSearchEngine(coveoOrganizationId, coveoApiKey, false)
      : coveoSearchEngine()
  const searchBoxController = buildSearchBox(coveoHeadlessSearchEngine, {
    options: {
      numberOfSuggestions: 5
    }
  })

  return (
    <>
      <div className="coveo-headless-search__bar">
        <div className="search-results__search-box">
          <Input
            controller={searchBoxController}
            placeholder={placeholder}
            urlSearchPage={urlSearchPage}
            clearButtonLabel={clearButtonLabel}
            searchButtonLabel={searchButtonLabel}
          />
        </div>
      </div>
    </>
  )
}

export default SearchBox
